<div class="wrapper">
  <cep-header-bar></cep-header-bar>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
